import React, { useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ChiamaWeb, { CChiamaWebParametri } from "../../../ChiamaWeb";
import * as Dati from "../../../Dati";
import * as Glob from "../../../Globale";
import { Trad } from "../../../components/";
import { _ButtonAPI } from "../../components";

interface ISecureCardProps {
    SetDialog: (V: Glob.CDialog) => void;
    UserId: number;
}

export const _SecureCard: React.FC<ISecureCardProps> = ({ SetDialog, UserId }) => {
    const [Data, setData] = useState<Dati.Dictionary<string>>({});

    useEffect(() => {
        GetSecureCard();
    }, [UserId]);

    const GetSecureCard = () => {
        const Param: CChiamaWebParametri = {
            URL: `/api/Utenti/GetCartaServizi?id_utente=${UserId}`,
            OnRis: (sender: ChiamaWeb, data: Dati.CRisAPIDizionario<string>) => {
                setData(data.Dati);
            },
            OnErrore: (sender: ChiamaWeb, errore: Error) => OnError(errore)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnClickGenerateSecureCard = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            SetDialog({ Open: true, Title: "ERRORE GENERAZIONE CARTA SERVIZI", Content: Trad.Trad(data.ErrTesto), Type: "error" });
        } else {
            SetDialog({ Open: true, Title: "GENERAZIONE CARTA SERVIZI", Content: Trad.Trad("GenerazioneCartaServiziAvvenutaConSuccesso"), Type: "success" });
            GetSecureCard();
        }
    };

    const OnError = (error: Error) => {
        SetDialog({ Open: true, Title: "ERRORE", Content: error.message, Type: "error" });
    };

    return (
        <Card>
            <CardHeader title={Trad.Trad("CartaServizi")} titleTypographyProps={{ variant: "h6" }} />
            {!!Object.keys(Data).length && (
                <CardContent>
                    <Box textAlign="center">
                        <Grid container spacing={2}>
                            {Object.keys(Data).map(key => {
                                return (
                                    <Grid item xs={3} key={key}>
                                        <Typography variant="subtitle2" component="span" color="secondary">
                                            {key.padStart(2, "0")}
                                        </Typography>
                                        {` ${Data[key]}`}
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Box>
                </CardContent>
            )}
            <CardActions disableSpacing>
                <Grid container item xs={12} justify="flex-end">
                    <_ButtonAPI
                        Testo={Trad.Trad("GeneraCartaServizi")}
                        URL={`/api/utenti/GeneraCartaServizi?ID_Utente=${UserId}`}
                        OnClick={OnClickGenerateSecureCard}
                        OnErrore={OnError}
                        Hidden={Glob.GetSessione().Gruppi.indexOf("1") < 0 && Glob.GetSessione().Gruppi.indexOf("CS") < 0}
                    />
                </Grid>
            </CardActions>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/User/SecureCard.tsx